{
  "example_demo": "示例",
  "example_i18n": "国际化",
  "example_icon": "图标",
  "example_responsive": "响应式",
  "platform": "平台管理",
  "platform_tenant": "企业管理",
  "platform_tenant_remark": "这个字段用于作为备注，用于描述菜单功能",
  "platform_tenant_add": "添加企业",
  "platform_tenant_add_api": "添加企业API",
  "system": "后台管理",
  "system_organization": "部门管理",
  "system_users": "用户管理",
  "system_users_remark": "这个字段用于作为备注，用于描述菜单功能",
  "system_roles": "权限管理",
  "system_user_add": "添加用户"
}
